import React from 'react';
import {
  Root,
  LoadingContainer,
  CircleWrapper,
  StyledCircularProgress,
  InnerCircle,
  LoadingText,
  SubText,
} from './CircleLoading.styles';

interface CircleLoadingProps {
  text?: string;
  subText?: string;
  size?: number;
}

const CircleLoading: React.FC<CircleLoadingProps> = ({
  text = 'Loading...',
  subText = 'Please wait',
  size = 80,
}) => {
  return (
    <Root>
      <LoadingContainer>
        <CircleWrapper>
          <StyledCircularProgress size={size} thickness={3} />
          <InnerCircle size={size} />
        </CircleWrapper>
        <LoadingText variant="h6">{text}</LoadingText>
        {subText && <SubText variant="body2">{subText}</SubText>}
      </LoadingContainer>
    </Root>
  );
};

export default CircleLoading;
